// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"260":"1de87451","453":"99798bf3","717":"a0e9682e"}[chunkId] + ".chunk.js";
};